import { PulseLoader } from "react-spinners";

export function Loader() {
  return (
    <div className="flex justify-center items-center">
      <PulseLoader
        color="color-mix(in srgb, var(--muted-foreground) 50%, transparent)"
        loading={true}
        size={15}
        speedMultiplier={0.6}
      />
    </div>
  );
}
